import * as angular from "angular";
import {IController} from "angular";
import {RuleFilterEntityType} from "../../types/rule-filter-entity.type";
import {RuleStageCondition} from "../../models/rule-stage-condition.model";
import {RuleFilterModel} from "../../models/rule-filter.model";
import {RuleConditionStage} from "../../models/rule-condition-stage.model";

export class RuleFiltersComponent implements IController {

  filterOptions: RuleFilterModel[];
  filters: RuleConditionStage;
  metaData: any[];
  onChangeFilters: Function;

  public optionFiltersMap: {} = {};

  constructor() {
  }

  onAddFilterCondition() {
    const filter: RuleStageCondition = {
      fieldName: undefined,
      operator: undefined,
      type: undefined,
      value: undefined,
      values: undefined
    }
    this.filters.conditions.push(filter);
  }

  onRemoveCondition(conditionIndex: number) {
    this.filters.conditions.splice(conditionIndex, 1);
  }

}


angular
  .module('bringoz.admin.ruleEngine')
  .component('ruleFilters', {
    bindings: {
      filterOptions: '<',
      filters: '<',
      metaData: '<?',
      onChangeFilters: '&'
    },
    template: require('./rule-filters.html').default,
    controller: RuleFiltersComponent
  });

